/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CategoryShopping: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.00001 3C4.51879 3 4.10582 3.34274 4.01713 3.81571L1.01714 19.8158C0.962313 20.1082 1.04052 20.4098 1.2305 20.6387C1.42049 20.8677 1.70253 21.0001 2.00001 21.0001L16 21.0001H22C22.2975 21.0001 22.5795 20.8676 22.7695 20.6387C22.9595 20.4098 23.0377 20.1082 22.9829 19.8158L19.9829 3.81571C19.8942 3.34274 19.4812 3 19 3H5.00001ZM3.20493 19.0001L5.82993 5H17.7951L15.1701 19.0001L3.20493 19.0001ZM17.2049 19.0001L19 9.42629L20.7951 19.0001H17.2049ZM7.49997 7.50002C7.49997 6.94773 7.94768 6.50002 8.49997 6.50002C9.05225 6.50002 9.49997 6.94773 9.49997 7.50002V8.50002C9.49997 9.0523 9.94768 9.50002 10.5 9.50002L11.5 9.50002C12.0523 9.50002 12.5 9.0523 12.5 8.50002V7.50002C12.5 6.94773 12.9477 6.50002 13.5 6.50002C14.0523 6.50002 14.5 6.94773 14.5 7.50002V8.50002C14.5 10.1569 13.1568 11.5 11.5 11.5H10.5C8.84312 11.5 7.49997 10.1569 7.49997 8.50002V7.50002Z'
      fill='currentColor'
    />
  </React.Fragment>
)
